import React from "react";
import { useParams } from "react-router-dom";
import MaterialTable from "material-table";
import Time from "../../../lithic/Moment";
import api from "../../../api";
import {
  apiCollectionToRowResponse,
  rowQueryToApiParams,
} from "../../../modules/tableQuery";
import tableIcons from "../../../components/tableIcons";
import { AdminContainer } from "../../../components/layouts";

export default function WebhookRequestsListPage() {
  const { id: partnerId } = useParams();
  const tableRef = React.createRef();

  const columns = [
    {
      title: "ID",
      field: "id",
      defaultSort: "desc",
      width: 100,
    },
    {
      title: "Event",
      field: "webhookEventName",
      width: 200,
    },
    {
      title: "Created At",
      field: "createdAt",
      width: 180,
      render: (rowData) => <Time formatExact={"MMM DD, YYYY HH:mm:ss"}>{rowData.createdAt}</Time>,
    },
    {
      title: "Status",
      field: "status",
      width: 100,
    },
    {
      title: "Webhook URL",
      field: "webhookUrl",
      width: 250,
      render: (rowData) => (
        <div
          style={{
            maxWidth: 250,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {rowData.webhookUrl}
        </div>
      ),
    },
    {
      title: "Request",
      field: "request",
      cellStyle: {
        minWidth: 1000,
        maxWidth: 1000,
        width: 1000,
      },
      headerStyle: {
        minWidth: 1000,
        maxWidth: 1000,
        width: 1000,
      },
      render: (rowData) => (
        <div
          style={{
            fontFamily: "monospace",
            fontSize: "0.75rem",
            whiteSpace: "pre-wrap",
            wordBreak: "break-all",
          }}
        >
          {rowData.request || "N/A"}
        </div>
      ),
    },
    {
      title: "Response",
      field: "response",
      width: 300,
      render: (rowData) => (
        <div
          style={{
            maxWidth: 300,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            fontFamily: "monospace",
            fontSize: "0.75rem",
          }}
        >
          {rowData.response || "N/A"}
        </div>
      ),
    }
  ];

  return (
    <AdminContainer variant="list">
      <MaterialTable
        title="Webhook Requests"
        tableRef={tableRef}
        columns={columns}
        options={{
          filtering: false,
          pageSize: 50,
          pageSizeOptions: [50, 100, 200],
          emptyRowsWhenPaging: false,
          search: true,
          searchFieldAlignment: "left",
          searchFieldStyle: { minWidth: 300 },
          thirdSortClick: false
        }}
        data={(q) => {
          const params = rowQueryToApiParams(q);
          return api
            .getPartnerWebhookRequests({
              partnerId: parseInt(partnerId),
              ...params,
            })
            .then((resp) => apiCollectionToRowResponse(resp));
        }}
        icons={tableIcons}
      />
    </AdminContainer>
  );
}
